import { TokenData } from "@listingweb-types"

export const verifyAuth = () => {
  try {
    const token = localStorage.getItem("listing_access_token")

    if (!token) {
      return false
    }

    const decodedToken = parseJwt(token)

    if (isTokenExpired(decodedToken.exp)) {
      return false
    }

    return true
  } catch (error) {
    return false
  }
}

export const parseJwt = (token: string): TokenData => {
  const base64Url = token.split(".")[1]
  const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/")
  const jsonPayload = decodeURIComponent(
    window
      .atob(base64)
      .split("")
      .map(function (c) {
        return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2)
      })
      .join("")
  )

  return JSON.parse(jsonPayload)
}

export const isTokenExpired = (exp: number) => {
  return exp * 1000 < Date.now()
}
